import styled from 'styled-components'

export const CompareView = styled.div`
  > h1 {
    margin: 30px 0;
  }

  .link-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: 30px;

    .back-link {
      display: block;
    }

    .bookmark-button {
      display: flex;
      justify-content: flex-start;
      padding-right: 5px;

      > span:first-child {
        font-size: 21px;
      }

      .label {
        margin-top: 2px;
        line-height: 21px;
      }

      @media ${ (props) => props.theme.breakpoints.devices.max.sm }, print {
        display: flex;
        justify-content: flex-start;
        width: auto;
        padding-top: 0;
        border: none;
      }
    }
  }

  // overwrite tab size (if just one item should rendered)
  .full-size {
    > ul > li {
      width: calc(100% - 4px);
    }
  }
`
